import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

const WORKER_URL =
  (import.meta.env.VITE_WORKER_URL as string | undefined) ||
  (import.meta.env.VITE_EMAIL_API_URL as string | undefined) ||
  'https://api.lessablesweb.fr'

type State = 'loading' | 'ok' | 'error'

export default function UnsubscribeProspectionPage() {
  const { token } = useParams<{ token: string }>()
  const [state, setState] = useState<State>('loading')
  const [email, setEmail] = useState<string | null>(null)

  useEffect(() => {
    if (!token) {
      setState('error')
      return
    }
    fetch(`${WORKER_URL}/api/unsubscribe/prospection/${token}`, { method: 'POST' })
      .then((r) => r.json())
      .then((d) => {
        if (d.ok) {
          setEmail(d.email ?? null)
          setState('ok')
        } else {
          setState('error')
        }
      })
      .catch(() => setState('error'))
  }, [token])

  return (
    <div className="min-h-screen flex items-center justify-center bg-cream-50 p-6">
      <div className="max-w-md w-full bg-white border border-brown-100 rounded-lg p-8 text-center">
        {state === 'loading' && <p className="text-brown-600">Traitement en cours…</p>}
        {state === 'ok' && (
          <>
            <h1 className="text-lg font-medium text-brown-900 mb-2">
              Désinscription confirmée
            </h1>
            <p className="text-sm text-brown-600">
              {email ? (
                <>
                  L'adresse <strong>{email}</strong> ne recevra plus nos emails de
                  prospection.
                </>
              ) : (
                'Vous ne recevrez plus nos emails de prospection.'
              )}
            </p>
          </>
        )}
        {state === 'error' && (
          <>
            <h1 className="text-lg font-medium text-brown-900 mb-2">Lien invalide</h1>
            <p className="text-sm text-brown-600">
              Le lien est expiré ou inconnu. Contactez-nous à contact@lessablesweb.fr.
            </p>
          </>
        )}
      </div>
    </div>
  )
}
